export const categorizedSkills = [
  {
    category: 'Preferred Practices',
    content: [
      'Test Driven Development',
      'Clean Code',
      'Continuous Refactoring',
      'Continuous Integration & Delivery',
      'Domain Driven Design',
      'User Centered Design',
      //TODO - Link Eric Reis
      'Lean Product',
      //TODO - Link 12 factor
      'Cloud Native & 12 Factor Architecture',
      //TODO - LInk paird programming reesarch
      'Paired Programming',
      //TODO - Find balanced team video
      'Balanced Team (high collaboration with product and design)',
      'Extreme Programming',
      //TODO - Link TBD
      'Trunk Based Development'
    ]
  },
  {
    category: 'CI/CD Tools',
    content: [
      'Concourse',
      'Jenkins',
      'GitLab CI',
      'Github Actions',
      'Bamboo'
    ]
  },
  {
    category: 'Deployment Environments',
    content: [
      'Kubernetes',
      'Pivotal Cloud Foundry (Tanzu Application Service)',
      'Heroku',
      'AWS (s3, ec2)'
    ]
  },
  {
    category: 'Patterns',
    content: [
      'Event Driven Architecture',
      'REST APIs',
      'Single Page Web Application',
      '12 Factor Applications',
      'Microservices',
      'SOLID',
      'Functional Programming',
      'Object Oriented Programming'
    ]
  },
  {
    category: 'Tools',
    content: [
      'Git',
      'RabbitMQ',
      'intelliJ',
      'macOS/Linux',
      'Postgres, MariaDB, MySQL',
      'Gradle',
      'npm'
    ]
  }
];

export const certifications = [
  'Certified Kubernetes Application Developer (CKAD) | Linux Foundation',
  'Certified Developer Java | Pivotal',
  'Certified Instructor - PAL for Developers (Java) | Pivotal',
];

export const languages = [
  {
    description: 'My Favorite Tools',
    languages: [
      'Kotlin',
      'Java',
      'Typescript',
      'Javascript',
      'HTML',
      'CSS',
      'SQL',

    ],
    libraries: [
      'Spring',
      'React',
      'Redux',
      'JUnit 4 & 5',
      'Cypress',
      'Mockito',
      'Rest Assured',
      'Mocha/Chai',
      'React Testing Library'
    ]
  },
  {
    description: 'Can Roll With',
    languages: [
      'Python',
      'Swift',
      'iOS',
      'Android'
    ],
    libraries: [
      'Angular',
      'Jasmine',
      'Pupeteer',
      'Jest',
      'Enzyme',
      'Vue',
      'Netflix Conductor',
    ]
  },
  {
    description: 'I\'ve Used it, but not for a while',
    languages: [
      'C++',
      'C#'
    ],
    libraries: [
      'Angular.JS',
      'Spring Cloud Contracts',
      'Spring Cloud Config',
      'Netflix Eureka',
    ]
  },
  {
    description: 'Actively learning',
    languages: [
      'Haskell',
    ],
    libraries: []
  },
  {
    description: 'Interested in',
    languages: [
      'Go',
      'Elm',
      'Clojure'
    ],
    libraries: []
  }
];
